import React from 'react';

const DualValueProgressBar = ({ used = 25, total = 100, filledColor = '#9F9FF8' }) => {
  const usedPercent = (used / total) * 100;
  const remaining = total - used;

  return (
    <div
      style={{
        position: 'relative',
        height: '14px',
        borderRadius: '12px',
        backgroundColor: '#ddd',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          width: `${usedPercent}%`,
          height: '100%',
          backgroundColor: filledColor,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          fontWeight: 'bold',
          fontSize: '10px',
        }}
      >
        {used}
      </div>
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: `${usedPercent}%`,
          width: `${100 - usedPercent}%`,
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 'bold',
          fontSize: '10px',
        }}
      >
        {remaining}
      </div>
    </div>
  );
};

export default DualValueProgressBar;
